import { inject, Injectable } from '@angular/core';
import { DialogManagerService } from '@services/utils/dialog-manager.service';
import { LegalOrganizationManager } from '@shared/interfaces/profile/legal-organization-manager';
import { ManagerContactDialogComponent } from '@cart/components/manager-contact-dialog/manager-contact-dialog.component';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Injectable()
export class StartingPriceBannerDialogService {
  private readonly dialogManagerService = inject(DialogManagerService);

  open(manager: LegalOrganizationManager | null): void {
    const config: DynamicDialogConfig = {
      width: '500px',
      showHeader: false,
    };

    this.dialogManagerService.openCustomDialog(ManagerContactDialogComponent, config, { manager });
  }
}
